import Vue from "vue";
import vuex from "vuex";

// 配置vuex是全局变量
Vue.use(vuex);
export default new vuex.Store({
  state: {
    dict: {
      /**
       * 订单状态
       * 0:待付款，1:待发货，2:待收货，3:已收货(交易成功)，4:退款中，
       * 5:退款完成(交易关闭)，6:退货退款中，7:退货退款完成(交易关闭)，8:超时未付款，订单自动关闭(交易关闭)，9:订单已取消(交易关闭)
       * 10.第三方退款中，11.第三方退款失败，12.第三方退货退款中，12.第三方退货退款失败
       */
      statusStrList: [
        {
          title: "等待买家付款",
          remark: ""
        },
        {
          title: "买家已付款",
          remark: "等待商家发货"
        },
        {
          title: "卖家已发货",
          remark: ""
        },
        {
          title: "交易成功",
          remark: "已收货"
        },
        {
          title: "退款中",
          remark: "等待商家确认"
        },
        {
          title: "退款成功",
          remark: ""
        },
        {
          title: "退货退款中",
          remark: "等待商家确认"
        },
        {
          title: "退货退款成功",
          remark: ""
        },
        {
          title: "交易关闭",
          remark: "超时未付款，订单自动关闭"
        },
        {
          title: "交易关闭",
          remark: "订单已取消"
        },
        {
          title: "退款中",
          remark: "商家已确认，支付平台退款中"
        },
        {
          title: "退款失败",
          remark: "商家已确认，支付平台退款失败"
        },
        {
          title: "退货退款中",
          remark: "商家已确认，支付平台退款中"
        },
        {
          title: "退货退款失败",
          remark: "商家已确认，支付平台退款失败"
        }
      ]
    },
    scrollerPosition: {
      goodsList: 0
    },
    carBadge: "0",
    loginShow: false,
    notAvailable: false,
    pcLoginShow: false,
    pcMAINPAGE: null,
    MAINPAGE: null,
    APPPAGE: null,
    token: null,
    userInfo: {
      poster: "",
      displayName: ""
    },
    weiXinConfig: null,
    // websock: null,
    wsdata: {
      // websocket 的 接收的数据
      msg: "",
      msgType: "",
      status: ""
    },
    pcCsrShow: false, // pc端客服弹窗
    customerToGoods: [], //  客服聊天关联商品
    unreadMessageNum: "0", // 未读消息数
    webLogData: [], // 网络日志
    CustomerPage: null, // 聊天页
    OrderDetailPage: null, //订单详情页
    NotificationPage: null, // 消息提示页
    notification: null, // 提示消息
    // 公众号 会员信息
    memberInfo: null,
    rechargeResultPAGE: null,
  }
});



// WEBPACK FOOTER //
// ./src/config/vuex.js